import { GetOrganizationSummariesResponseBodyType } from "@intelligems/ig-types";
import { organizationsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

const getOrganizationSummaries = async () => {
  const resp = await api.get<GetOrganizationSummariesResponseBodyType>(
    `/v2/admin/organizations`
  );
  return resp.data;
};

export const useGetOrganizationSummaries = () => {
  return useQuery<GetOrganizationSummariesResponseBodyType>({
    queryKey: organizationsKeys.orgSummaries,
    queryFn: async () => getOrganizationSummaries(),
  });
};
